import React from 'react';
import logo from './logo.svg';
import './App.css';
import Posts from './components/Posts'
import Navbar from './components/Navbar'

function App() {
  return (
    <div className="App">
      <Navbar />
      <div id="content" className="container">
        <div className="columns">
          <div className="column is-two-thirds">
            <Posts />
          </div>
          <div className="column">
            <p>Suggested follows</p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default App;
